'use client';

import type { ReactElement } from 'react';
import { SessionData } from '@auth0/nextjs-auth0/types';
import { usePathname } from 'next/navigation';
import CaretIcon from './icons/CaretIcon';
import UIButton from './buttons/UIButton';

export default function Login({
  session,
  hasCaret = false,
}: {
  session: null | SessionData;
  hasCaret?: boolean;
}): ReactElement | null {
  const pathname = usePathname();

  if (session) {
    return null;
  }

  return (
    <UIButton
      buttonType="secondary"
      label="Log In"
      href={`/auth/login?returnTo=${pathname}`}
      prefetch={false}
      className="login-btn"
      data-testid="login"
      icon={hasCaret && <CaretIcon size="large" direction="right" />}
    />
  );
}
